var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"d-flex justify-content-center align-items-center"},[_c('a',{staticClass:"d-flex justify-content-center",attrs:{"href":_vm.target_url,"rel":"noopener noreferrer"}},[_c('img',{staticStyle:{"width":"80%","height":"auto"},attrs:{"src":require('@/assets/Logo.png'),"alt":"Forever Living"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }